import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../services/api';

// onSuccess — called after verification when the user is already authenticated
// (skips the "Sign in" button and refreshes auth state instead)
export default function VerifyEmail({ onSuccess } = {}) {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link.');
      return;
    }

    api
      .post('/api/v1/auth/verify-email', { token })
      .then(() => {
        setStatus('success');
        if (onSuccess) onSuccess();
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Verification failed. The link may have expired.');
      });
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900">
      <div className="max-w-md w-full card text-center space-y-4">
        <h1 className="text-3xl font-bold text-primary-600">Sage</h1>

        {status === 'verifying' && (
          <p className="text-neutral-600 dark:text-neutral-400">Verifying your email…</p>
        )}

        {status === 'success' && (
          <>
            <div className="text-green-600 dark:text-green-400 text-lg font-medium">Email verified!</div>
            <p className="text-neutral-600 dark:text-neutral-400 text-sm">
              {onSuccess ? 'Taking you to setup…' : 'Your email has been confirmed. You can now sign in.'}
            </p>
            {!onSuccess && (
              <Link to="/login" className="btn btn-primary inline-block">
                Sign in
              </Link>
            )}
          </>
        )}

        {status === 'error' && (
          <>
            <div className="text-danger-600 dark:text-danger-400 text-lg font-medium">Verification failed</div>
            <p className="text-neutral-600 dark:text-neutral-400 text-sm">{message}</p>
            <Link to="/login" className="text-primary-600 hover:text-primary-700 text-sm font-medium">
              Back to sign in
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
